import { render } from "./signup.vue?vue&type=template&id=f28b9868&scoped=true"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"

import "./signup.vue?vue&type=style&index=0&id=f28b9868&scoped=true&lang=css"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28b9868"]])

export default __exports__